<div class="modal-header">
  <h5 class="modal-title" id="newGroupLabel" i18n="@@CreateNewGroupHeader">Neue Gruppe erstellen</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="onCancelClick()"></button>
</div>

<div class="modal-body">
  <div class="container">
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)" *ngIf="formCreated">
      <div class="form-group row">
        <label class="nested required" i18n="@@GroupNameLabel">Gruppenname*</label>
        <input id="input_groupname" type="text" formControlName="name" class="form-control"
          i18n-placeholder="@@NameOfChargingGroupPlaceholder" placeholder="Gruppenname*" required />

        <div class="error">
          <em *ngIf="formService.validateControl('name') && formService.hasError('name', 'required')"
            i18n="@@GroupNameRequiredErrorMessage">
            Gruppenname wird benötigt
          </em>
        </div>
      </div>

      <div class="form-group row">
        <label class="nested" i18n="@@DescriptionLabel">Beschreibung (optional)</label>
        <textarea id="input_groupdescription" formControlName="description" rows="3" class="form-control"
          i18n-placeholder="@@OptionalDescriptionPlaceholder" placeholder="Beschreibung (optional)"></textarea>
      </div>

      <div class="form-group row">
        <label for="chargingstations" class="form-label persistent" i18n="@@ChargingstationsLabel">Ladestationen</label>
        <ng-select id="chargingstations" [appendTo]="'body'" [items]="chargingstations"
          bindLabel="name" formControlName="selectedChargingstations" multiple="true" [closeOnSelect]="false" [clearSearchOnAdd]="true" [hideSelected]="true"
          i18n-notFoundText="@@NoEntriesAvailable" notFoundText="Keine Einträge vorhanden" placeholder="Ladestationen zuordnen" i18n-placeholder="@@ChooseChargingsations">
          <ng-template ng-label-tmp let-item="item">
            <span class="px-2">{{ item.name }}</span>
            <span class="ng-value-icon right" (click)="clearChargingStation(item)">×</span>
          </ng-template>
        </ng-select>
      </div>

      <div class="form-group row">
        <label for="users" class="form-label persistent" i18n="@@UsersLabel">Benutzer</label>
        <ng-select id="users" [appendTo]="'body'" [items]="users" bindLabel="fullName"  multiple="true" [closeOnSelect]="false" [clearSearchOnAdd]="true" [hideSelected]="true"
          formControlName="selectedUsers" placeholder="Benutzer zuordnen" i18n-placeholder="@@ChooseUsers"
          [compareWith]="compareUsersById"
          [searchFn]="userMultiSelectSearchFn"
          i18n-notFoundText="@@NoEntriesAvailable" notFoundText="Keine Einträge vorhanden">
          <ng-template ng-label-tmp let-item="item">
            <span class="px-2">{{ item.fullName + ' (' + item.email + ')' }}</span>
            <span class="ng-value-icon right" (click)="clearUser(item)">×</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span class="px-2">{{ item.fullName + ' (' + item.email + ')' }}</span>
          </ng-template>
        </ng-select>
      </div>

    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow d-inline me-1" data-bs-dismiss="modal"
    (click)="onCancelClick()" i18n="@@CancelButton">Schließen</button>
  <button type="submit" id="save" class="btn btn-save" (click)="onSubmit(formService.form.value)"
     i18n="@@SaveButton" [disabled]="formService.form?.invalid || !formService.form?.dirty">Änderungen speichern</button>
</div>

